import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_1 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/UserLogo.vue';
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/ScrollerList/index.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('view-box', {
    ref: "viewBox",
    staticClass: "viewBox"
  }, [_c(__unplugin_components_0, {
    ref: "orderList",
    staticStyle: {
      "position": "relative z-index: 2"
    },
    attrs: {
      "is-px": "",
      "height": _vm.scrollerHight,
      "total": _vm.list.length
    },
    on: {
      "on-pulldown-loading": _vm.onPulldownLoading,
      "on-pullup-loading": _vm.onPullupLoading
    }
  }, _vm._l(_vm.list, function (item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "card vux-1px-b"
    }, [_c('div', {
      staticClass: "header font-size-h2-large"
    }, [_c(__unplugin_components_1, {
      staticStyle: {
        "margin": "0 auto"
      },
      attrs: {
        "size": 4,
        "name": item.writer_name,
        "show-border": true,
        "border-width": 0,
        "border-color": "transparent"
      }
    })], 1), _c('div', {
      staticClass: "content"
    }, [_c('p', [_vm._v(_vm._s(item.content))]), _c('div', {
      staticClass: "flex"
    }, _vm._l(item.images, function (v, i) {
      return _c('div', {
        key: i,
        staticClass: "img"
      }, [_c('img', {
        attrs: {
          "src": v.file_url,
          "alt": i18n.tc("381")
        },
        on: {
          "click": function ($event) {
            return _vm.showPic(item.images, i);
          }
        }
      })]);
    }), 0), _c('div', {
      staticClass: "footer"
    }, [_c('p', [_vm._v(_vm._s(item.createtime))])])])]);
  }), 0), _c('div', {
    staticClass: "bottom-bar",
    attrs: {
      "slot": "bottom"
    },
    slot: "bottom"
  }, [_c('div', {
    staticClass: "btn-body"
  }, [_c('x-button', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function ($event) {
        _vm.showAddMssage = true;
      }
    }
  }, [_vm._v(i18n.tc("440"))])], 1)]), _c('div', {
    directives: [{
      name: "transfer-dom",
      rawName: "v-transfer-dom"
    }]
  }, [_c('Previewer', {
    ref: "previewer",
    attrs: {
      "list": _vm.imglist
    }
  })], 1), _c('AddMssage', {
    attrs: {
      "id": _vm.id
    },
    on: {
      "callback": function ($event) {
        return _vm.loadList(true);
      }
    },
    model: {
      value: _vm.showAddMssage,
      callback: function ($$v) {
        _vm.showAddMssage = $$v;
      },
      expression: "showAddMssage"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };